import qs from 'qs';

const Log = {
    namespaced: true,

    state: {
        logData: [],
        logFirstData: [],
        firstGet: true,
    },

    
    

    getters: {
        logData (state) {
            return state.logData;
        },
        logFirstData (state) {
            return state.logFirstData;
        },
        isFirstGet (state){
            return state.firstGet;
        }
    },

    mutations: {

        /**
         * Установить значение объекта
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['logData'] = items;
        },
        /**
         *  делаем копию логов при первом обновлении, для последующего сравнения с новыми логами и выводом уведомлений
         * @param {*} state 
         * @param {*} param1 
         */
        setArrFirst (state, { items }) {
            if(state['firstGet']){ 
                state['logFirstData'] = items;
                state['firstGet'] = false;
            }
        },
        /**
         * Флаг обновления прочитанных сообщений 
         * @param {*} state 
         * @param {*} param1 
         */
        setIsFirst (state, { items }) {
            state['firstGet'] = items;
        },

        /**
         * Обновить значение элемента объекта
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['logData'][index] = item;
        },

        /**
         * Добавить значение элемента объекта
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['logData'].push(item);
        },

        /**
         * Удалить элемент из объекта
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['logData'] = state['logData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение данных по логам
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getLogData ({ commit, dispatch, getters, rootGetters }) {
            
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl +  'log/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                    commit('setArrFirst', {
                        items: response.data
                    }), 
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные лога получены.'),
                        resolve()
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN log.js | getLogData : ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных лога!'),
                        reject(err);
                });

 
            })
            
        },

        /**
         * Удаление записей лога (поддерживается пакетное удаление
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */

        removeLogData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.items.map(el => {return el.id}));
                axios({
                    url: rootGetters.rootUrl + 'log/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                    }),
                }).then(response => (
                    data.items.forEach(el => {
                        commit('remove', {
                            item: el,
                        });
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Записи лога успешно удалены!'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении роли!'),
                    console.log('ERROR IN store.js | removeRoleData : ' + err);
                    reject(err);
                });
            })
        },
        /**
         * Очистка уведомлений о новых ошибках в логах
         * @param {*} param0 
         */
        setIsFirst ({ commit, dispatch, getters, rootGetters }) {
            commit('setIsFirst', {
                items: true
            });
            commit('setArrFirst', {
                items: getters.logData
            });
        }
    },
};

export default Log;





// WEBPACK FOOTER //
// ./src/store/modules/log.js